// contexts/CacheContext.js
import React, { createContext, useContext } from 'react';
import { useCache } from '../hooks/Usecache';
const CacheContext = createContext(null);
/**
 * Wrap your app with <CacheProvider> (inside App.js).
 * All children can call useAppCache() to share the same cache instance.
 */
export const CacheProvider = ({ children }) => {
  const cache = useCache();
  return <CacheContext.Provider value={cache}>{children}</CacheContext.Provider>;
};

export const useAppCache = () => {
  const ctx = useContext(CacheContext);
  if (!ctx) throw new Error('useAppCache must be used inside <CacheProvider>');
  return ctx;
};